const INITIAL_STATE = {
    error:"",
}; 
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "LOGIN_REQUEST":
            return {...state,user:action.payload,error:action.error}
        default:
            return state;
    }
}
